var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',[_c('section',{staticClass:"forms component",class:_vm.name,style:({
             'background-image': ("url(" + (_vm.acf.layout['background-image']) + ")"),
             'background-color': _vm.acf.layout['background-color']
            }),attrs:{"resmed-component-name":"product_review"}},[_c('div',{staticClass:"container"},[_c('div',{staticClass:"row"},[_c('div',{staticClass:"col"},[_c(_vm.active,{tag:"component",attrs:{"acf":_vm.acf}})],1)])])])])}
var staticRenderFns = []

export { render, staticRenderFns }